angular.module('gym.components').directive('gocardlessPaymentDetails', function() {
  return {
    restrict: 'EA',
    scope: {
      paymentMethods: '=',
      setDefault: '&',
      reloadPaymentMethods: '&',
      permissions: '='
    },
    template: require('templates/components/contacts/wallet/gocardless_payment_details.html.slim'),
    controller: ["$scope", "$window", "ContactGoCardlessService", "AdminUserService", function($scope, $window, ContactGoCardlessService, AdminUserService) {
      $scope.adminHasPermission = AdminUserService.has;
      $scope.setDefault = function(item) {
        if ($window.confirm('This will change the Mandate used for payment processing. Are you sure?')) {
          return ContactGoCardlessService.setDefault(item).then(function() {
            $scope.reloadPaymentMethods();
            return $scope.$emit('contact:mandates:reload');
          });
        }
      };
      return $scope.getAvailableItems = function() {
        return _.filter($scope.paymentMethods, function(item) {
          return item.show_in_wallet;
        });
      };
    }]
  };
});
